export const Constants = {
    AllowanceType: ['PAYCHECK', 'VACATION', 'SEVERANCE', 'ALLOWANCE', 'BONUS', 'OTHER'],
    PayFrequencyType: ['HOURLY', 'DAILY', 'WEEKLY', 'BI-WEEKLY', 'MONTHLY', 'SEMI-MONTHLY', 'QUARTERLY', 'OTHER']
};
export const APP_DATE_FORMATS =
{
    parse: {
        dateInput: 'MMM DD, YYYY'
     },
     display: {
        dateInput: 'input',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'MMMM DD, YYYY',
        monthYearA11yLabel: 'MMMM YYYY'
     } 
};


// WEBPACK FOOTER //
// ./src/app/common/constants/constants.ts